import { render, staticRenderFns } from "./CouvertureBesoins.vue?vue&type=template&id=29dc510f&scoped=true"
import script from "./CouvertureBesoins.vue?vue&type=script&lang=js"
export * from "./CouvertureBesoins.vue?vue&type=script&lang=js"
import style0 from "./CouvertureBesoins.vue?vue&type=style&index=0&id=29dc510f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dc510f",
  null
  
)

export default component.exports